// extracted by mini-css-extract-plugin
export default {"header":"bXL9ai2xS8jdECrColMI","label":"Jp4iD4Um7xtnfFKBkesA","body":"LQos88zvDl5FEl5PQ7ys"};